/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourcePoolProviderType } from './resourcePoolProviderType';
import { ResourcePoolRequestStatusType } from './resourcePoolRequestStatusType';
import { ResourcePoolRequestOperationType } from './resourcePoolRequestOperationType';


export interface TenantResourcePoolEntrySpec { 
    /**
     * Org id
     */
    org_id: string;
    provider_type: ResourcePoolProviderType;
    operation: ResourcePoolRequestOperationType;
    status: ResourcePoolRequestStatusType;
    /**
     * Assigned Resource Id
     */
    assigned_resource_id?: string;
    /**
     * Request id
     */
    request_id: string;
    request_spec: object;
    /**
     * Requested by
     */
    requested_by: string;
    /**
     * Task Id
     */
    task_id?: string;
}
export namespace TenantResourcePoolEntrySpec {
}


